import type { DateTime } from "luxon";

/** Halloween decorations run Oct 24 – Nov 1, both days included. Encoded as month * 100 + day. */
const SEASON_START = 1024;
const SEASON_END = 1101;
const MONTH_FACTOR = 100;

export const isHalloweenSeason = (date: DateTime): boolean => {
	const monthDay = date.month * MONTH_FACTOR + date.day;
	return monthDay >= SEASON_START && monthDay <= SEASON_END;
};
